
namespace GeniuzPOS.PosShift {
    import fld = PsPosShiftControlViewRow.Fields;

    @Serenity.Decorators.registerClass()
    export class PsPosShiftControlViewGrid extends Serenity.EntityGrid<PsPosShiftControlViewRow, any> {
        protected getColumnsKey() { return PsPosShiftControlViewColumns.columnsKey; }
        protected getDialogType() { return PsPosShiftControlViewDialog; }
        protected getIdProperty() { return PsPosShiftControlViewRow.idProperty; }
        protected getInsertPermission() { return PsPosShiftControlViewRow.insertPermission; }
        protected getLocalTextPrefix() { return PsPosShiftControlViewRow.localTextPrefix; }
        protected getService() { return PsPosShiftControlViewService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected createQuickSearchInput() {
        }

        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            Q.first(filters, x => x.field == fld.SingInDate).init = w => {

                (w as Serenity.DateEditor).valueAsDate = new Date(new Date().setDate(new Date().getDate()-6));

                let endDate = w.element.nextAll(".s-DateEditor").getWidget(Serenity.DateEditor);
                endDate.valueAsDate = new Date(Date.now());
            };

            // var q = Q.parseQueryString();
            // if (q["ShopId"]) {
            //     var category = Q.tryFirst(filters, x => x.field == "ShopId");
            //     category.init = e => {
            //         e.element.getWidget(Serenity.LookupEditor).value = q["ShopId"];
            //     };
            // }


            return filters;
        }

        protected getButtons() {
			var button = super.getButtons();
            
                
                button.push(
                    {
                        title: Q.text("Close"), // *** Get button text from translation
                        cssClass: '.panel-titlebar-close',
                        icon: 'fa-close',
                        onClick: () => {
                            window.location.href = '/';
                            return false;
                        },
                    }
                );            
                
			button.splice(Q.indexOf(button, x => x.cssClass == "add-button"), 1);
			return button;
		}
    }
}